<template>
    <div>
        <div class="info-container__title--big">
            {{ data.installationName || data.serialNumber || '-' }}
        </div>
        <div class="info-container">
            <div class="info-container__line">
                <div class="info-container__line info-container__line--grouped">
                    <div class="brick">
                        <b class="info-container__title">
                            {{
                                $t('paygo.clientInfo.title', { i18nFallback: 'Client information' })
                            }}
                        </b>
                        <div class="info-container__text">{{ data.name || '-' }}</div>
                        <div class="info-container__text">{{ data.phoneNumber || '-' }}</div>
                        <div class="info-container__text">{{ data.email || '-' }}</div>
                    </div>

                    <div class="brick">
                        <b class="info-container__title--small">
                            {{ $t('paygo.clientInfo.gps', { i18nFallback: 'GPS Coordinates' }) }}
                        </b>
                        <div class="info-container-text">{{ data.gps || '-' }}</div>
                    </div>
                </div>

                <div class="brick brick--20">
                    <b class="info-container__title--small">
                        {{
                            $t('paygo.clientInfo.installationKey', {
                                i18nFallback: 'Private installation key',
                            })
                        }}
                    </b>
                    <div v-if="show" class="info-container__text info-container__privateKey">
                        {{ data.installationKey || '-' }}
                    </div>
                    <div v-if="!show" class="info-container__text info-container__privateKey">
                        XXXXXXXXXXXXXXXXXXXXXXXXXXXXXX
                    </div>
                    <div
                        class="info-container__clickable info-container__right"
                        @click="show = !show"
                    >
                        {{ $t('paygo.clientInfo.clickTo', { i18nFallback: 'Click to ' }) }}
                        {{
                            !show
                                ? $t('paygo.clientInfo.show', { i18nFallback: 'show' })
                                : $t('paygo.clientInfo.hide', { i18nFallback: 'hide' })
                        }}
                    </div>
                </div>
            </div>
            <div class="info-container-breaking-line"></div>
            <b class="info-container__title">
                {{
                    $t('paygo.clientInfo.summary', { i18nFallback: 'Installation amount summary' })
                }}
            </b>
            <div class="info-container__line">
                <div class="brick">
                    <b class="info-container__title--small">
                        {{ $t('paygo.clientInfo.currency', { i18nFallback: 'Currency' }) }}
                    </b>
                    <div class="info-container-text">
                        ({{ getCurrencySymbol() }}) {{ data.currency || '-' }}
                    </div>
                </div>
                <div class="brick brick--25">
                    <b class="info-container__title--small">
                        {{
                            $t('paygo.clientInfo.totalValue', {
                                i18nFallback: 'Total value of installation',
                            })
                        }}
                    </b>
                    <div class="info-container__text">
                        {{ getCurrencySymbol() }} {{ formatDecimal(data.totalCost) || '-' }}
                    </div>
                </div>
                <div class="brick">
                    <b class="info-container_title--small">
                        {{
                            $t('paygo.clientInfo.totalPaid', { i18nFallback: 'Total amount paid' })
                        }}
                    </b>
                    <div class="info-container__text">
                        {{ getCurrencySymbol() }} {{ formatDecimal(totalPaid) || '-' }} of
                        {{ formatDecimal(data.totalCost) | '-' }}
                    </div>
                </div>
                <div class="brick brick--20">
                    <b class="info-container__title--small">
                        {{ $t('paygo.clientInfo.amountLeft', { i18nFallback: 'Amount left' }) }}
                    </b>
                    <div class="info-container__text">
                        {{ getCurrencySymbol() }}
                        {{
                            data.totalCost && totalPaid
                                ? formatDecimal(data.totalCost - totalPaid)
                                : '-'
                        }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style></style>
<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import { AngularDirective } from '@/vue/decorators/angular-interop';
import { AngularLocaleBundle } from '@/angular-bridge/modules/i18n';
import CurrencyMap from '@/utils/currency.js';
import { ngInject } from '@/vue/decorators/angular-interop';
@Component({
    components: {},
})
@AngularDirective('vrm-paygo-client-info')
@AngularLocaleBundle('paygo')
export default class VrmPaygoClientInfo extends Vue {
    @Prop()
    installation;
    @Prop()
    totalPaid;
    @Prop()
    paygoSecrets;
    @ngInject()
    ApiService;

    show = false;
    data = {
        userId: '',
        serialNumber: '',
        installationName: '',
        name: '',
        phoneNumber: '',
        email: '',
        gps: '-',
        installationKey: '',
        totalCost: 0,
        totalPaid: 0,
        currency: '-',
    };

    async mounted() {
        this.installation.then(site => {
            this.UpdateClientInfo(site);
        });
        this.paygoSecrets.then(key => {
            this.data.installationKey = key.data.paygoPrivateKey;
        });
    }

    formatDecimal(value) {
        return value.toFixed(2);
    }

    async UpdateClientInfo(site) {
        this.data.currency = site.paygoCurrency;
        this.data.totalCost = site.paygoTotalAmount;
        this.data.installationName = site.name;
        const response = await this.ApiService.call2(`/installations/${site.id}/users`);
        let user;
        for (let i = 0; i < response.data.users.length; i++) {
            if (response.data.users[i].accessLevel === 0) {
                user = response.data.users[i];
                break;
            }
        }
        if (!user) user = response.data.users[0];
        this.data.userId = user.idUser;
        this.data.name = user.name;
        this.data.email = user.email;
        this.ApiService.call2(
            `/users/${this.data.userId}/info`,
            {},
            { throwOnError: false, skipResultChecks: true },
        ).then(data => {
            this.data.phoneNumber = data.data.phone;
        });

        const gpsData = await this.ApiService.installations(site.id, 'weather');
        if (gpsData.data.records.lt && gpsData.data.records.lg)
            this.data.gps = '' + gpsData.data.records.lt + ', ' + gpsData.data.records.lg;
    }

    getCurrencySymbol() {
        return CurrencyMap[this.data.currency];
    }
}
</script>
